var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.585,
    height: 96.529,
    viewBox: "0 0 104.585 96.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4871",
    "data-name": "Group 4871",
    transform: "translate(-571.229 -124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4872",
    "data-name": "Group 4872",
    transform: "translate(571.229 124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning",
    "data-name": "Icon ionic-ios-warning",
    d: "M48.849,8.5,4.33,89.742a7.641,7.641,0,0,0,6.812,11.287h89.063a7.658,7.658,0,0,0,6.812-11.287L62.474,8.5A7.8,7.8,0,0,0,48.849,8.5Zm11.237,33.71-.9,30.668H52.143l-.9-30.668Zm-4.424,47.36a4.629,4.629,0,1,1,4.8-4.625A4.67,4.67,0,0,1,55.662,89.566Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#fecd3a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ec99501a5496faf8f3d7b0341b425cd6.svg";
export { ForwardRef as ReactComponent };